import React, { useEffect, useRef, useState, useMemo } from "react";

import "./locationTile.css";
import { useAppDispatch } from "../../redux/hooks";
import { groupType } from "../../interfaces/groups";
import PermissionAction from "../permissions/PermissionAction";
import ExpanIcon from "../../svg/expandIcon";
import { Modal } from "@mantine/core";
import LocationIcon from "../../svg/locationIcon";
import { useNavigate } from "react-router-dom";
import AddressIcon from "../../svg/addressIcon";
import { Tooltip } from "@mantine/core";
import ClockIcon from "../../svg/clockIcon";
import { FiBookmark } from "react-icons/fi";
import { RiSettings4Fill } from "react-icons/ri";
import { favoritesLocsAndFloors } from "../../interfaces/bookmarks";

export interface locationTileProps {
  group: groupType;
  setSelectedCat: any;
  favorites: favoritesLocsAndFloors;
  setFavorites: (inp: any) => void;
}

export function LocationsTile({
  group,
  setSelectedCat,
  favorites,
  setFavorites,
}: locationTileProps) {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const removeFavoriteLoc = () => {
    setFavorites((prev) => ({
      ...prev,
      locations: prev.locations.filter((el) => el !== group.id),
    }));
  };

  const isFavoriteLocation = favorites.locations.includes(group.id);

  const addFaviouriteLoc = () => {
    setFavorites((prev) => ({
      ...prev,
      locations: [...prev.locations, group.id],
    }));
  };

  const workingHours = useMemo(() => {
    return group.openingTime
      ? Object.entries(group.openingTime)
          .map(([day, times]) => {
            if (times) {
              const [startTime, endTime] = (times as string).split("-");
              const formattedStartTime = startTime && `${startTime.trim()}`;
              const formattedEndTime = endTime && `${endTime.trim()}`;
              return {
                day: day.slice(0, 3),
                time: `${formattedStartTime} - ${formattedEndTime}`,
              };
            }
            return null;
          })
          .filter((el) => el !== null)
      : [];
  }, [group.openingTime]);
  console.log('statusss', group.name, group.live)
  const daysOrder = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const sortedWorkingHours = workingHours.sort(
  (a, b) => daysOrder.indexOf(a.day) - daysOrder.indexOf(b.day)
);
const isCurrentlyOpen = () => {
  const today = new Date();
  const dayOfWeek = today.toLocaleString("en-US", { weekday: "long" });
  const currentTime = today.getHours() + today.getMinutes() / 60; 

  
  const times = group.openingTime ? group.openingTime[dayOfWeek] : null;
  if (!times || times.trim() === "") return false; 

  const [startTime, endTime] = times.split("-");
  
  const parseTime = (time: string) => {
    const [hour, modifier] = time.trim().split(" ");
    let [hours, minutes] = hour.split(":").map(Number);

    if (modifier === "PM" && hours < 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    return hours + minutes / 60;
  };

  const startHour = parseTime(startTime);
  const endHour = parseTime(endTime);

 
  if (startHour === endHour) return true; 
  
  
  return currentTime >= startHour && currentTime <= endHour;
};


  return (
    <PermissionAction operation="R" resource="locations">
      <div
        className={`relative flex flex-col rounded-3xl w-full min-h-[500px] border border-grayText4  border-solid bg-white `}
      >
        {isFavoriteLocation ? (
          <div
            onClick={removeFavoriteLoc}
            className={`rounded-[50%] w-10 h-10 flex bg-actionLight text-action justify-center items-center  absolute right-2 top-3 text-2xl cursor-pointer`}
          >
            <FiBookmark fill="#FB6514" />
          </div>
        ) : (
          <div
            onClick={addFaviouriteLoc}
            className={`rounded-[50%] w-10 h-10 flex  text-grayText3 bg-white justify-center items-center  absolute right-2 top-3 text-2xl cursor-pointer`}
          >
            <FiBookmark />
          </div>
        )}

        <div
          className={`rounded-[30px] px-4 py-2 absolute left-3 top-3 ${
            group.live && isCurrentlyOpen() ? "bg-successLight" : "bg-actionLight"
          }`}
        >
          {group.live && isCurrentlyOpen() ? (
            <div className="flex gap-2 items-center justify-center">
              <div className="h-2 w-2 rounded-[50%] bg-success" />
              <p>open</p>
            </div>
          ) : (
            <div className="flex gap-2 items-center justify-center">
              <div className="h-2 w-2 rounded-[50%] bg-action" />
              <p>closed</p>
            </div>
          )}
        </div>

        <div
          className="w-full h-56 cursor-pointer "
          onClick={(e) => {
            setSelectedCat(group.id);
          }}
        >
          {group.imageURL ? (
            <img
              width="100%"
              height="100%"
              className="rounded-t-[20px]"
              src={group.imageURL}
              alt={group.name}
            />
          ) : (
            <div className="w-full rounded-t-[20px]  bg-grayText4 h-full  flex items-center justify-center">
              <AddressIcon width="80px" height="60px" />
            </div>
          )}
        </div>

        <div className="flex flex-col gap-4 px-8 pt-4 pb-5 flex-1">
          <h1 className="font-medium text-2xl  text-black  flex items-center">
            {group.name}
          </h1>
          <div className="bg-grayText4 h-[1.2px] w-full " />

          <div className="flex flex-col gap-2 flex-1 justify-center ">
            <div className="flex gap-3 items-center w-full">
              <LocationIcon />

              <p className="text-grayText3 text-md max-w-full flex-1  whitespace-nowrap overflow-hidden text-ellipsis">
                {group.address}
              </p>
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://www.google.com/maps?q=[${group.address}]`}
              >
                <ExpanIcon className="text-action cursor-pointer" />
              </a>
            </div>

            <div className="flex gap-3 items-center">
              <ClockIcon />

              {workingHours.length > 0 ? (
                <Tooltip
                label={
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {sortedWorkingHours.map((el, index) => {
                      const is24Hours = el.time === "08:00 AM - 08:00 AM";
                      return (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                            padding: "4px 0",
                          }}
                        >
                          <span style={{ width: "50px", fontWeight: "bold" }}>{el.day}</span>
                          {is24Hours ? (
                            <span style={{ marginLeft: "auto", marginRight: "auto" }}>24 Hours</span>
                          ) : (
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <span style={{ marginRight: "10px" }}>{el.time.split(" - ")[0]}</span>
                              <span style={{ margin: "0 10px" }}>-</span>
                              <span>{el.time.split(" - ")[1]}</span>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                }
                withArrow
              >
                <div className="flex-1 text-grayText2 text-ellipsis whitespace-nowrap overflow-hidden max-w-full">
                  {sortedWorkingHours.slice(0, 3).map((el, index) => {
                    const is24Hours = el.time === "08:00 AM - 08:00 AM";
                    return (
                      <span key={index} className="text-grayText2 text-md">
                        {` ${el.day} ${is24Hours ? "24 Hours" : el.time}`},
                      </span>
                    );
                  })}
                </div>
              </Tooltip>
              ) : (
                <p className="text-grayText2 text-md text-ellipsis  whitespace-nowrap overflow-hidden max-w-full">
                  Everyday, 09:00AM - 05:00PM
                </p>
              )}
            </div>
            <div className="flex gap-3 items-center">
              <AddressIcon width="20px" height="19px" />
              <p className="text-grayText3 text-md flex-1 text-ellipsis  whitespace-nowrap overflow-hidden ">
                {`${group.floors} Total floors - ${group.desks} Desks`}
              </p>
            </div>
          </div>
          <div className="w-full flex gap-2 h-auto">
            <button
              onClick={(e) => {
                setSelectedCat(group.id);
              }}
              className=" flex-1 hover:bg-action rounded-[100px] font-md  hover:text-white py-3 text-md bg-actionLight text-action"
            >
              See Floors & Desks
            </button>
            <PermissionAction operation="U" resource="locations">
              <Tooltip label="Site Settings" withArrow>
                <div
                  onClick={() => navigate(`/editSpace/${group.id}`)}
                  className={`rounded-[50%] w-10 h-10 flex bg-actionLight text-action hover:bg-action hover:text-actionLight  justify-center items-center   text-2xl cursor-pointer`}
                >
                  <RiSettings4Fill />
                </div>
              </Tooltip>
            </PermissionAction>
          </div>
        </div>
      </div>
    </PermissionAction>
  );
}

export function LocationsTilesSpacer() {
  return <div className="locationTile_container" style={{ height: 0 }} />;
}

export default LocationsTile;
